/**
 * Password policy: 8–72 chars, upper, lower, digit, and at least one special character.
 * Special = any non-alphanumeric (includes _ . ? - ! @ # etc.)
 */
export const PASSWORD_RE = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,72}$/;
export const HAS_SPECIAL_CHAR_RE = /[^A-Za-z0-9]/;

export function passwordRequirements(password = '') {
  return {
    len: password.length >= 8 && password.length <= 72,
    lower: /[a-z]/.test(password),
    upper: /[A-Z]/.test(password),
    num: /\d/.test(password),
    special: HAS_SPECIAL_CHAR_RE.test(password),
  };
}
